import React from "react";
import "../styles/Legal.css";
import Footer from "../components/Footer";

const Terms = () => {
  return (
    <>
      <div className="legal-container">
        <h1 className="legal-title">Terms & Conditions</h1>
        <p className="legal-date">Effective Date: October 2025 • Last Updated: October 2025</p>

        <div className="legal-content">
          <p>
            <strong>
              CJet Dispatch (BN 8223233, Nigeria) & CJet Dispatch LLC (Entity ID 0008028488, New Mexico, USA)
            </strong>
            <br />
            Registered Offices:
            <br />• 2nd House Beside Mopo Barrack, Ilorin, Kwara State, Nigeria
            <br />• 70 Tripp Dr, Talladega, AL 35160, United States
            <br />
            Contact: support@cjetdispatch.com • Website:{" "}
            <a href="https://cjetdispatch.com" target="_blank" rel="noreferrer">
              https://cjetdispatch.com
            </a>
          </p>

          <h2>Legal Entity Information</h2>
          <p>
            CJet Dispatch operates under the following registered entities:
            <ul>
              <li>
                🇳🇬 <strong>CJet Dispatch</strong> — Registered Business Name under the Companies and Allied
                Matters Act, 2020 (BN 8223233). Principal Office: 2nd House Beside Mopo Barrack, Ilorin, Kwara State, Nigeria.
              </li>
              <li>
                🇺🇸 <strong>CJet Dispatch LLC</strong> — Limited Liability Company in the State of New Mexico, United States
                (Entity ID: 0008028488). Registered Office: 70 Tripp Dr, Talladega, AL 35160, USA. Registered Agent: Rocket
                Corporate Services Inc., 1012 Marquez Place, Suite 106B, Santa Fe, NM 87505, USA.
              </li>
            </ul>
            Together, these entities operate as “<strong>CJet Dispatch</strong>” (“CJet,” “we,” “our,” or “us”).
          </p>

          <h2>1) Agreement to Terms</h2>
          <p>
            These Terms & Conditions (“Terms”) form a binding agreement between CJet and any person or entity that
            accesses or uses our website, dashboard, or services (the “Platform”). By using the Platform, you agree to
            these Terms. If you do not agree, discontinue use immediately.
          </p>

          <h2>2) Nature of Services</h2>
          <p>
            <strong>2.1 Platform & Courier Role:</strong> CJet Dispatch operates as a licensed courier service and logistics
            technology platform. We enable users to create dispatch orders for documents and parcels, generate tracking
            numbers, and view shipment status and history.
          </p>
          <p>
            <strong>2.2 Dual Operation Model:</strong> Depending on the route and service tier, CJet may:
          </p>
          <ul>
            <li>Perform courier/dispatch services directly through its authorized operations; or</li>
            <li>
              Facilitate delivery through independent third-party carriers or logistics providers (“Third-Party Providers”).
            </li>
          </ul>
          <p>
            Where a Third-Party Provider executes transport, that provider is solely responsible for physical pickup,
            handling, transport, and delivery. CJet’s role is limited to coordination, tracking, and communication support.
          </p>
          <p>
            <strong>2.3 Limitation of Scope:</strong> CJet is not a bank, financial institution, escrow, or customs broker. We do
            not provide legal or tax advice. Customs documentation and compliance remain the shipper’s responsibility unless
            otherwise agreed in writing.
          </p>

          <h2>3) User Eligibility & Accounts</h2>
          <p>
            You represent that you have legal capacity to contract and will use the Platform in compliance with all
            applicable laws. You are responsible for safeguarding your login details and all activity under your account.
          </p>

          <h2>4) User Obligations</h2>
          <ul>
            <li>Provide accurate sender/recipient information, item descriptions, declared values, and documents.</li>
            <li>Comply with applicable laws, sanctions/export controls, and carrier rules.</li>
            <li>Avoid dispatching Prohibited items and follow all Restricted item conditions (Section 10).</li>
            <li>Bear all fees, duties, taxes, penalties, storage, or assessment charges that arise.</li>
          </ul>

          <h2>5) Orders, Tracking & Service Levels</h2>
          <ul>
            <li>An order is accepted when confirmed by CJet or a Third-Party Provider.</li>
            <li>Tracking numbers are issued by carriers and surfaced by CJet for visibility.</li>
            <li>
              Delivery ETAs are not guarantees and may be impacted by weather, customs, operational constraints, or force
              majeure.
            </li>
          </ul>

          <h2>6) Pricing, Payment & Currency</h2>
          <ul>
            <li>Fees are shown at checkout or in your dashboard.</li>
            <li>Payment is due in full at order submission via approved methods.</li>
            <li>
              Foreign exchange rates are applied by your bank or payment gateway; CJet does not set or guarantee rates.
            </li>
            <li>Orders may be suspended or cancelled for non-payment, suspected fraud, or disputes.</li>
          </ul>

          <h2>7) Refunds, Cancellations & Disputes</h2>
          <ul>
            <li>Fees are non-refundable once a dispatch is submitted and/or a tracking number is issued.</li>
            <li>
              Report duplicates or errors within 7 business days. Verified duplicates are refunded within 5–10 business days.
            </li>
            <li>Repeated or abusive chargebacks may result in suspension or termination.</li>
            <li>Loss/damage/delay claims must be filed directly with the carrier as per their rules.</li>
          </ul>

          <h2>8) Customs, Inspections & Regulatory Matters</h2>
          <p>
            You are responsible for accurate customs declarations and compliance. Shipments may be opened or inspected by
            authorities. CJet has no control over inspections or resulting delays, penalties, or seizures.
          </p>

          <h2>9) Risk of Loss; Insurance</h2>
          <p>
            Risk transfers to the carrier upon acceptance of your item. Insurance, if available, is provided by a Third-Party
            Provider or insurer, subject to their own terms.
          </p>

          <h2>10) Prohibited & Restricted Items</h2>

          <p>
            <strong>Prohibited (examples, non-exhaustive):</strong><br />
            Illegal drugs or controlled substances; weapons, ammunition, explosives; counterfeit or stolen goods; obscene or
            pornographic materials; cash, coins, bearer instruments; and hazardous or toxic materials prohibited by law or carrier
            policy.
          </p>

          <p>
            <strong>Restricted (examples):</strong><br />
            Alcohol, tobacco, prescription medication (with valid authorization), perishables, lithium batteries, regulated
            chemicals, high-value items such as jewelry or bullion — shipped strictly at the user’s risk.
          </p>

          <p>
            <strong>Checks & Negotiable Instruments:</strong><br />
            CJet Dispatch permits the dispatch of checks, drafts, and negotiable instruments addressed to named recipients. Such
            items are handled strictly as physical courier documents and remain subject to applicable banking and financial
            regulations.
          </p>

          <ul>
            <li>The clearing, verification, or settlement of such instruments.</li>
            <li>Any returned, fraudulent, or non-sufficient-funds (NSF) checks.</li>
            <li>Any disputes or losses arising from bank rejections, reversals, or fraudulent issuance.</li>
          </ul>

          <p>
            All checks dispatched through CJet are transmitted under the <strong>Check Clearing for the 21st Century Act (Check
              21)</strong> framework, where applicable. CJet acts solely as a delivery intermediary and not as a financial
            institution or clearing agent.
          </p>


          <h2>11) Financial & Negotiable Instruments Disclaimer</h2>
          <p>
            CJet is not a bank or money services business and does not verify authenticity, enforce payment, or guarantee
            clearance of checks or negotiable instruments. Such items remain subject to applicable banking laws, including
            the U.S. Check 21 Act.
          </p>

          <h2>12) Intellectual Property</h2>
          <p>
            All Platform content and technology are owned by CJet or its licensors and protected by intellectual property
            laws. No license is granted except for lawful use.
          </p>

          <h2>13) Warranties & Disclaimers</h2>
          <p>
            THE PLATFORM IS PROVIDED “AS IS” AND “AS AVAILABLE.” CJET DISCLAIMS ALL WARRANTIES, EXPRESS OR IMPLIED,
            INCLUDING MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE, AND NON-INFRINGEMENT.
          </p>

          <h2>14) Limitation of Liability</h2>
          <p>
            CJET SHALL NOT BE LIABLE FOR INDIRECT, INCIDENTAL, SPECIAL, OR CONSEQUENTIAL DAMAGES. OUR TOTAL LIABILITY SHALL
            NOT EXCEED THE FEES PAID FOR THE AFFECTED ORDER.
          </p>

          <h2>15) Indemnification</h2>
          <p>
            You agree to defend, indemnify, and hold harmless CJet and its personnel from any claims or expenses arising from
            your use of the Platform or violation of these Terms.
          </p>

          <h2>16) Suspension & Termination</h2>
          <p>
            We may suspend or terminate access at any time for suspected fraud, non-payment, or breach of Terms. All due
            amounts become payable immediately.
          </p>

          <h2>17) Changes to the Platform or Terms</h2>
          <p>
            We may modify or discontinue parts of the Platform and update these Terms at any time. Continued use constitutes
            acceptance.
          </p>

          <h2>18) Governing Law & Venue</h2>
          <ul>
            <li>
              <strong>Nigeria Users:</strong> Governed by the laws of the Federal Republic of Nigeria. Venue: Kwara State or
              other competent Nigerian courts.
            </li>
            <li>
              <strong>United States Users:</strong> Governed by U.S. federal and New Mexico state law, with venue in New Mexico.
            </li>
          </ul>

          <h2>19) Notices</h2>
          <p>
            Email: support@cjetdispatch.com <br />
            Postal: 2nd House Beside Mopo Barrack, Ilorin, Kwara State, Nigeria
          </p>

          <h2>20) Miscellaneous</h2>
          <ul>
            <li>Severability: Invalid provisions do not affect the remainder.</li>
            <li>Assignment: You may not assign rights without consent.</li>
            <li>Entire Agreement: These Terms supersede prior understandings.</li>
            <li>No Waiver: Failure to enforce any term is not a waiver.</li>
          </ul>

          <p className="legal-footer">© 2025 CJet Dispatch LLC. All rights reserved.</p>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Terms;